import { Dispatch, SetStateAction, useState } from 'react';

import { PreInterviewPreviewContextDialog } from './PreInterviewPreviewContextDialog';

type PreInterviewPreviewContextDialogOpenerRenderProps = {
   setTriggerElement: Dispatch<SetStateAction<HTMLElement | null>>;
};

type PreInterviewPreviewContextDialogOpenerProps = {
   readonly children: (renderProps: PreInterviewPreviewContextDialogOpenerRenderProps) => JSX.Element;
   readonly appointmentId: number;
};

export const PreInterviewPreviewContextDialogOpener = (
   props: PreInterviewPreviewContextDialogOpenerProps
): JSX.Element => {
   const [triggerElement, setTriggerElement] = useState<HTMLElement | null>(null);

   return (
      <>
         {props.children({
            setTriggerElement: setTriggerElement,
         })}

         <PreInterviewPreviewContextDialog triggerElement={triggerElement} appointmentId={props.appointmentId} />
      </>
   );
};
